import { Button, Stack, Typography } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { OverridableStringUnion } from '@mui/types';
import React, { useRef } from 'react';

import FormEndOptions from '../components/forms/FormEndOptions';
import useModal from './useModal';

interface ButtonPropsColorOverrides {}

type ButtonColor = OverridableStringUnion<
  'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
  ButtonPropsColorOverrides
>;

function useConfirm(
  messageParam:
    | string
    | { message?: string; title?: string; confirmButtonColor?: ButtonColor; confirmButtonText?: string },
  dependencyArray: any[] = []
) {
  let title: string = 'Please confirm:';
  let message: string;
  let confirmButtonColor: ButtonColor = 'primary';
  let confirmButtonText: string = 'OK';

  if (typeof messageParam === 'object') {
    title = messageParam?.title || title;
    message = messageParam?.message || message;
    confirmButtonColor = messageParam?.confirmButtonColor || confirmButtonColor;
    confirmButtonText = messageParam?.confirmButtonText || confirmButtonText;
  } else {
    message = messageParam;
  }

  let closeModal;
  const resolveRef = useRef(null);

  const yes = () => {
    if (resolveRef.current) {
      resolveRef.current(true);
    }

    closeModal();
  };

  const no = () => {
    if (resolveRef.current) {
      resolveRef.current(false);
    }
    closeModal();
  };

  const [openConfirmModal, closeConfirmModal] = useModal(
    () => (
      <Stack spacing={2}>
        <Stack p={1}>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body1">{message}</Typography>
        </Stack>
        <FormEndOptions>
          <Stack direction="row" justifyContent="center" width="100%" spacing={2}>
            <Button onClick={no} variant="outlined">
              Cancel
            </Button>
            <Button onClick={yes} color={confirmButtonColor}>
              {confirmButtonText}
            </Button>
          </Stack>
        </FormEndOptions>
      </Stack>
    ),
    null,
    [...dependencyArray, title, message, confirmButtonColor, confirmButtonText]
  );

  closeModal = closeConfirmModal;

  const windowDotConfirm = () =>
    new Promise((resolve) => {
      resolveRef.current = resolve;
      openConfirmModal();
    });

  return {
    windowDotConfirm,
  };
}

export default useConfirm;
